export const LOAD_PAY_HISTORY_REQUEST = 'LOAD_PAY_HISTORY_REQUEST';
export const LOAD_PAY_HISTORY_SUCCESS = 'LOAD_PAY_HISTORY_SUCCESS';
export const LOAD_PAY_HISTORY_FAILURE = 'LOAD_PAY_HISTORY_FAILURE';

export const LOAD_PAY_HISTORY_MORE_REQUEST = 'LOAD_PAY_HISTORY_MORE_REQUEST';
export const LOAD_PAY_HISTORY_MORE_SUCCESS = 'LOAD_PAY_HISTORY_MORE_SUCCESS';
export const LOAD_PAY_HISTORY_MORE_FAILURE = 'LOAD_PAY_HISTORY_MORE_FAILURE';

